(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-product-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var revealItems = document.querySelectorAll('.vg-reveal');

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0.14,
          rootMargin: '0px 0px -45px 0px',
        }
      );

      revealItems.forEach(function (item) {
        observer.observe(item);
      });
    } else {
      revealItems.forEach(function (item) {
        item.classList.add('is-visible');
      });
    }

    document.querySelectorAll('[data-vg-qty]').forEach(function (button) {
      button.addEventListener('click', function () {
        var wrap = button.closest('.vg-qty-wrap');
        if (!wrap) return;

        var input = wrap.querySelector('.vg-qty-input');
        if (!input) return;

        var value = parseInt(input.value, 10) || 1;

        if (button.dataset.vgQty === 'plus') {
          input.value = value + 1;
        } else {
          input.value = value > 1 ? value - 1 : 1;
        }

        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    var variantSelectEl = document.querySelector('[data-vg-variant]');
    if (variantSelectEl && variantSelectEl.tagName === 'SELECT') {
      variantSelectEl.addEventListener('change', function () {
        var opt = this.options[this.selectedIndex];
        var price = opt && opt.dataset.price;
        if (price) {
          var priceEl = document.querySelector('.vg-price');
          if (priceEl) priceEl.textContent = price;
          var stickyPriceEl = document.querySelector('.vg-sticky-cta-price');
          if (stickyPriceEl) stickyPriceEl.textContent = price;
        }
      });
    }

    var sticky = document.getElementById('vg-sticky-cta');
    var hero = document.querySelector('.vg-hero');

    if (sticky && hero) {
      window.addEventListener(
        'scroll',
        function () {
          if (hero.getBoundingClientRect().bottom < 0) {
            sticky.classList.add('is-visible-sticky');
          } else {
            sticky.classList.remove('is-visible-sticky');
          }
        },
        { passive: true }
      );
    }

    function scrollToForm() {
      var form = document.getElementById('vg-form-main');

      if (form) {
        form.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }

    var stickyBtn = document.getElementById('vg-sticky-btn');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', scrollToForm);
    }

    var finalScroll = document.getElementById('vg-final-scroll');
    if (finalScroll) {
      finalScroll.addEventListener('click', scrollToForm);
    }

    var buyNow = document.getElementById('vg-buy-now');

    if (buyNow) {
      buyNow.addEventListener('click', function () {
        var variantSelect = document.querySelector('[data-vg-variant]');
        var qtyInput = document.querySelector('.vg-qty-input');
        var variantId = variantSelect ? variantSelect.value : '';
        var quantity = qtyInput ? qtyInput.value : 1;

        if (variantId) {
          window.location.href = '/cart/' + variantId + ':' + quantity + '?checkout';
        }
      });
    }

    var form = document.getElementById('vg-form-main');

    if (form) {
      form.addEventListener('submit', function () {
        var button = document.getElementById('vg-atc-btn');

        if (button) {
          button.classList.add('is-loading');
          button.textContent = 'Agregando...';
        }
      });
    }

    var thumbButtons = document.querySelectorAll('.vg-slide-thumb');
    var mainImage = document.getElementById('vg-main-image');

    if (thumbButtons.length && mainImage) {
      thumbButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          var src = button.dataset.vgImage;
          var alt = button.dataset.vgAlt || '';
          var ratio = button.dataset.vgRatio || '1';
          var mainFrame = mainImage.closest('.vg-slider-main');

          if (mainFrame && ratio) {
            mainFrame.style.setProperty('--vg-media-ratio', ratio);
          }

          mainImage.style.opacity = '0';

          setTimeout(function () {
            mainImage.src = src;
            mainImage.alt = alt;
            mainImage.style.opacity = '1';
          }, 160);

          thumbButtons.forEach(function (btn) {
            btn.classList.remove('is-active');
          });

          button.classList.add('is-active');
        });
      });
    }

    document.querySelectorAll('.vg-product-description button').forEach(function (btn) {
      if (!btn.onclick && !btn.getAttribute('onclick')) {
        btn.addEventListener('click', function () {
          var f = document.getElementById('vg-form-main');
          if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
          else window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    });

    window.vgSetQty = function (packIndex) {
      var select = document.querySelector('[data-vg-variant]');
      if (select && select.tagName === 'SELECT') {
        var opt = select.options[packIndex - 1];
        if (opt) {
          select.value = opt.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        var qtyInput = document.querySelector('.vg-qty-input');
        if (qtyInput) {
          qtyInput.value = packIndex;
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      scrollToForm();
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
